var map = {
	"./ic_avax_40.svg": 475,
	"./ic_bnb_40.svg": 476,
	"./ic_btc_40.svg": 330,
	"./ic_eth_40.svg": 331,
	"./ic_frax_40.svg": 477,
	"./ic_glp_40.svg": 479,
	"./ic_link_40.svg": 480,
	"./ic_mim_40.svg": 481,
	"./ic_uni_40.svg": 482,
	"./ic_usdc.e_40.svg": 483,
	"./ic_usdc_40.svg": 484,
	"./ic_usdt_40.svg": 485,
	"./ic_wavax_40.svg": 486,
	"./ic_wbnb_40.svg": 487,
	"./ic_weth_40.svg": 488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 902;